import React from "react";
import ImageSlider from "../../../components/common/SlideShowImage/ImageSlider";
import images from "../../../images";
import { useTranslation } from "react-i18next";

const HeaderQuestPratice = ({
  thumbnails,
  consumerStatus,
  businessAvatar,
  fileName,
  menuHandleClick,
  menuIcon,
  onMenuClick,
  isDropDownOpen,
  onDropDownPauseClick,
  onDropDownEndClick,
  handleEdit,
  btnEdit,
  classNameBtnEdit,
  subTitle,
  onDropReportClick,
  quotaType,
}) => {
  const { t } = useTranslation();

  // console.log("qoutaType", quotaType);

  return (
    <div className="flex flex-col justify-center w-full bg-white">
      <div className="w-full relative rounded-md">
        <ImageSlider
          images={thumbnails}
          imageHeight={
            consumerStatus === "NOT_STARTED" ? "h-[75px]" : "h-[75px]"
          }
          applyImageOverlay={true}
        />
        {menuIcon ? (
          <>
            {isDropDownOpen && (
              <div
                className="fixed inset-0 bg-white opacity-0 z-40"
                onClick={() =>
                  typeof onMenuClick === "function" && onMenuClick()
                }
              />
            )}
            <div
              onClick={() => typeof onMenuClick === "function" && onMenuClick()}
              className="absolute top-[30px] right-6 cursor-pointer z-50"
            >
              <img
                loading="lazy"
                src={menuIcon}
                alt="Avatar"
                className="object-contain self-stretch my-auto w-6 h-6 rounded-md aspect-square"
              />
              {isDropDownOpen && (
                <div className="flex flex-col absolute right-[12px] top-[23px] z-50 px-4 justify-center items-center bg-white rounded-[10px]  shadow-[0_2px_6px_-2px_rgba(0,0,0,0.08)] border-[#EEEAE8] border-solid border-[1px]">
                  {quotaType === "SLOT" && (
                    <div
                      onClick={() =>
                        typeof onDropDownPauseClick === "function" &&
                        onDropDownPauseClick()
                      }
                      className="w-full cursor-pointer  py-1 rounded-t-[10px]"
                    >
                      <div className="flex flex-row justify-center items-center  py-1.5 px-2 gap-2 ">
                        <img
                          src={images.CarbonPauseOutlineBlue}
                          alt=""
                          className="w-4 h-4"
                        />
                        <span className="text-sm text-[#253FF6]">
                          {t("quest.detailMultipleChoice.pauseQuest")}
                        </span>
                      </div>
                    </div>
                  )}

                  <div
                    onClick={() =>
                      typeof onDropDownEndClick === "function" &&
                      onDropDownEndClick()
                    }
                    className=" cursor-pointer border-t-2   py-1.5 rounded-b-[10px]"
                  >
                    <div className="flex flex-row justify-center items-center px-2 py-1.5  gap-2  ">
                      <img
                        src={images.CarbonCloseOutlineBlue}
                        alt=""
                        className="w-4 h-4"
                      />
                      <span className="text-sm text-[#253FF6]">
                        {t("quest.detailMultipleChoice.quitQuest")}
                      </span>
                    </div>
                  </div>
                  <div
                    onClick={() =>
                      typeof onDropReportClick === "function" &&
                      onDropReportClick()
                    }
                    className=" cursor-pointer border-t-2   py-1.5 rounded-b-[10px]"
                  >
                    <div className="flex flex-row justify-center items-center px-2 py-1.5  gap-2  ">
                      <img
                        src={images.CircleWarningIconBlue}
                        alt=""
                        className="w-4 h-4"
                      />
                      <span className="text-sm text-[#253FF6]">
                        {t("base.report")}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : btnEdit ? (
          <button className={classNameBtnEdit} onClick={handleEdit}>
            {btnEdit}
          </button>
        ) : subTitle ? (
          <div
            onClick={() =>
              typeof onDropDownEndClick === "function" && onDropDownEndClick()
            }
            className="flex bg-white cursor-pointer px-1 overflow-hidden gap-[6px] justify-center items-center self-stretch my-auto rounded-[5px] h-[32px] w-[80px]"
          >
            <span className="text-xs text-[#EF4056]">{subTitle}</span>
          </div>
        ) : (
          <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]" />
        )}
        <div
          className={`flex absolute ${
            consumerStatus === "NOT_STARTED" ? "top-6" : "top-6"
          } left-8 flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20`}
        >
          <figure className="flex shrink-0 self-stretch my-auto" />
          {businessAvatar ? (
            <img
              src={`${process.env.REACT_APP_URL_IMAGE}/${businessAvatar}`}
              className="w-[70px] h-[70px] rounded-md object-cover"
              alt={fileName || ""}
            />
          ) : (
            <img
              src={images.RetailStoreIcon}
              className="w-[70px] h-[70px] rounded-full object-scale-down"
              alt={fileName || ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderQuestPratice;
